import React, { useState } from "react";
import { useQuery } from "react-query";

import { BiCheck, BiX } from "react-icons/bi";
import { FaClock, FaLock } from "react-icons/fa";
import { ThreeDots } from "react-loader-spinner";
import api from "src/rest/api";
import ProtocolsInfoList from "./ProtocolsInfoList";
import "./styles.css";

interface ProtocolQueryResult {
  active?: string[]; // Quantidade de protocolos que serão ativados
  inactive?: string[]; // Quantidade de protocolos que serão ativados
  activate?: string[]; // Quantidade de protocolos que serão desativados
  deactivate?: string[]; // Lista de protocolos (ou nula se não houver)
}

const CalendarScreen: React.FC = () => {
  const [ids, setIds] = useState<string[]>();

  const { data, isLoading } = useQuery(["events"], () =>
    api.post<ProtocolQueryResult>("/events/protocols").then((res) => res.data),
  );

  if (isLoading || !data) {
    return (
      <div className="m-auto flex w-full max-w-7xl flex-1 items-center justify-center">
        <ThreeDots color="black" height={12} />
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-7xl md:m-auto">
      <div className="grid max-w-7xl grid-cols-4 gap-4 px-4">
        <div className="col-span-4">
          <h4 className="text-xl font-semibold">Resumo de Protocolos</h4>
        </div>
        {/* Linha que ocupa 2 linhas */}
        <div className="col-span-4 grid h-[180px] grid-cols-4 gap-6 rounded">
          <button
            className="number-active number-card"
            onClick={() => setIds(data.active)}
          >
            <p className="number-title">
              <BiCheck className="mr-2" /> ATIVOS
            </p>

            <div className="number-card-count">{data.active?.length || 0}</div>
          </button>
          <button className="number-card" onClick={() => setIds(data.inactive)}>
            <p className="number-title">
              <BiX className="mr-2" />
              INATIVOS
            </p>

            <div className="number-card-count">
              {data.inactive?.length || 0}
            </div>
          </button>

          <button className="number-card" onClick={() => setIds(data.activate)}>
            <p className="number-title">
              <FaClock className="mr-2" />
              ATIVAÇÃO AGENDADA
            </p>

            <div className="number-card-count">
              {data.activate?.length || 0}
            </div>
          </button>
          <button className="number-card">
            <div className="number-title">
              <FaLock className="mr-2" />
              DESATIVAÇÃO AGENDADA
            </div>

            <div
              className="number-card-count"
              onClick={() => setIds(data.deactivate)}
            >
              {data.deactivate?.length || 0}
            </div>
          </button>
        </div>
        {/* Linha que ocupa 1 linha */}
        {ids && (
          <div className="col-span-4 mb-4 flex flex-col bg-white">
            <h2 className="pb-5 pt-2 text-xl font-semibold">
              Protocolos ({ids.length > 20 ? 20 : ids.length} de {ids.length})
            </h2>
            <ProtocolsInfoList list={ids} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarScreen;
